import React from 'react';

import Toolbar from './toolbar.jsx';
import TextPanel from './text-panel.jsx';
import Toolbar2 from './toolbar2.jsx';
import LayersList from './layers-list.jsx';

const { $ } = window;

export default class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project
    };
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  render() {
    let project = this.state.project;
    let textLayer = (project.activePage && project.activePage.selectedLayer && project.activePage.selectedLayer.type == 'text') ? project.activePage.selectedLayer : null;

    return (
      <div id="sideBar">
        <Toolbar project={project} />
        <TextPanel project={project} textLayer={textLayer} />
        <Toolbar2 project={project} />
        <LayersList project={project} />
      </div>
    );
  }
}
